import React from "react";

import { Badge } from "../../../components/ui";
import { QUOTE_STAGES, stageOf } from "./useQuoteActions";
import "./quote-stage-track.scss";

const STAGE_TONE = {
  created: "muted",
  to_review: "warning",
  approved: "accent",
  quote_sent: "info",
  accepted_by_client: "success",
  listed: "success",
};

// A linked listing that is still a draft is "listed" for the track, but the badge says so; a sent
// sell quote says what it was sent as.
const SEND_TYPE = { SP: "SP", CONSIGN: "consign", SP_CONSIGN: "SP & consign" };
const stageLabel = (quote, stage) => {
  if (quote?.quote_expired) return "Expired";
  if (stage === "quote_sent" && quote?.type === "sell" && SEND_TYPE[quote?.quote_send_type]) {
    return `Sent · ${SEND_TYPE[quote.quote_send_type]}`;
  }
  if (stage === "listed" && ["new", "submitted"].includes(quote?.listing?.status)) return "Listing draft";
  return QUOTE_STAGES.find((s) => s.id === stage)?.label;
};

/** The quote's current stage as a Badge — shared by the quote workspace and the quote editor. */
export function QuoteStageBadge({ quote }) {
  const stage = stageOf(quote);
  return (
    <Badge tone={quote?.quote_expired ? "danger" : STAGE_TONE[stage]} dot>
      {stageLabel(quote, stage)}
    </Badge>
  );
}

/** One bar per stage, filled up to the current one; labels show where there is room. */
export default function QuoteStageTrack({ quote }) {
  const stageIndex = QUOTE_STAGES.findIndex((s) => s.id === stageOf(quote));

  return (
    <ol className="qst" aria-label="Quote progress">
      {QUOTE_STAGES.map((s, i) => (
        <li
          key={s.id}
          className={`qst__step${i < stageIndex ? " is-done" : ""}${i === stageIndex ? " is-current" : ""}`}
          aria-current={i === stageIndex ? "step" : undefined}
        >
          <span className="qst__bar" aria-hidden="true" />
          <span className="qst__label">{s.label}</span>
        </li>
      ))}
    </ol>
  );
}
